import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-61d68a77"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "内购后台", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", {
  class: "upload-emphasis"
}, "导出配置表并上传至微信后台", -1));
const _hoisted_3 = {
  class: "next-step-guide"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "1. 导出本次商品", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("strong", null, "2. 上传微信后台"), /*#__PURE__*/_createElementVNode("span", null, "将配置表上传至微信后台完成配置；内购后台发布成功不代表微信侧已经生效。")], -1));
const _hoisted_6 = {
  key: 0,
  class: "failure"
};
const _hoisted_7 = {
  key: 1
};
import { computed, ref } from 'vue';
import { message } from 'ant-design-vue';
import { submitGoods } from '@/api/goodsSetting';
import { passProduct, originPublishProduct } from '@/api/goodsJudge';
import { useAppDimensionStore } from '@/store/appDimension';
import { publishMallProducts } from '../services/weixinMall';
import { downloadMallExport } from '../services/weixinMallExport';
export default /*#__PURE__*/_defineComponent({
  __name: 'WeixinMallPublishModal',
  props: {
    open: {
      type: Boolean
    },
    dataSource: null,
    dbtId: null
  },
  emits: ['close', 'refresh'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    // 打开时冻结勾选集合，后续列表刷新不会改变本次复确认范围。
    const rows = props.dataSource.map(item => ({
      ...item
    }));
    const context = {
      dbtId: props.dbtId,
      prodChnl: 'weixin',
      productScene: 'MALL'
    };
    const loading = ref(false);
    const downloading = ref(false);
    const finished = ref(false);
    // 每个商品只保留一个处理结果；null 表示已确认发布成功。
    const results = ref(new Map());
    const successIds = computed(() => [...results.value].filter(([, result]) => result === null).map(([id]) => id));
    const failures = computed(() => [...results.value.values()].filter(result => result !== null));
    const applyResults = (success, failed) => {
      success.forEach(id => results.value.set(id, null));
      failed.forEach(result => results.value.set(result.id, result));
    };
    const retryableFailures = computed(() => failures.value.filter(item => !item.unknown));
    const exportError = ref();
    const optTypes = {
      0: '新增商品',
      10: '修改商品',
      20: '下线',
      30: '上线'
    };
    const columns = [{
      title: '商品类型',
      dataIndex: 'prodType'
    }, {
      title: '内购ID',
      dataIndex: 'prodId'
    }, {
      title: '商品名称',
      dataIndex: 'prodName'
    }, {
      title: '商品图片',
      dataIndex: 'mallImage'
    }, {
      title: '当前价格',
      dataIndex: 'prodPrice'
    }, {
      title: '审核类型',
      dataIndex: 'optType'
    }];
    const failureFor = id => failures.value.find(item => item.id === id);
    const close = () => {
      if (loading.value || downloading.value) return;
      if (finished.value) emit('refresh');
      emit('close');
    };
    const publish = async () => {
      if (loading.value || downloading.value) return;
      loading.value = true;
      try {
        const retry = finished.value ? retryableFailures.value : rows.map(item => ({
          id: item.id
        }));
        const result = await publishMallProducts(retry, {
          submit: ids => submitGoods({
            ...context,
            productList: ids
          }),
          pass: ids => passProduct({
            ...context,
            productList: ids
          }),
          publish: ids => originPublishProduct({
            ...context,
            productList: ids.map(id => ({
              id
            }))
          })
        });
        applyResults(result.successIds, result.failures);
        exportError.value = undefined;
        finished.value = true;
        emit('refresh');
        useAppDimensionStore().loadGoodsJudgeDimensions(true);
      } finally {
        loading.value = false;
      }
    };
    const download = async () => {
      if (loading.value || downloading.value) return;
      downloading.value = true;
      try {
        await downloadMallExport({
          ...context,
          prodIds: rows.filter(item => successIds.value.includes(item.id)).map(item => item.prodId)
        });
        exportError.value = undefined;
        if (!failures.value.length) {
          emit('refresh');
          emit('close');
        } else message.success('成功商品已导出，可继续处理失败商品');
      } catch (error) {
        exportError.value = error instanceof Error ? error.message : '下载失败，请重试导出';
        message.error(exportError.value);
      } finally {
        downloading.value = false;
      }
    };
    return (_ctx, _cache) => {
      const _component_a_alert = _resolveComponent("a-alert");
      const _component_a_result = _resolveComponent("a-result");
      const _component_a_image = _resolveComponent("a-image");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_space = _resolveComponent("a-space");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.open,
        title: _unref(successIds).length ? '下一步：导出并上传微信后台' : '确认商城道具配置',
        width: _unref(successIds).length && !_unref(failures).length ? 620 : 960,
        centered: "",
        "mask-closable": false,
        closable: !loading.value && !downloading.value,
        onCancel: close,
        footer: null
      }, {
        default: _withCtx(() => [!_unref(successIds).length ? (_openBlock(), _createBlock(_component_a_alert, {
          key: 0,
          class: "mall-warning",
          type: "warning",
          "show-icon": ""
        }, {
          message: _withCtx(() => [_createTextVNode(" 微小商城道具在 "), _hoisted_1, _createTextVNode(" 生效后，必须 "), _hoisted_2, _createTextVNode(" ，商品才可以被正常使用。 ")]),
          _: 1
        })) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_a_result, {
          status: _unref(failures).length ? 'warning' : 'success',
          title: _unref(failures).length ? `成功发布${_unref(successIds).length}个，失败${_unref(failures).length}个` : '内购后台发布成功',
          "sub-title": `本次共发布${_unref(successIds).length}个商品，请导出配置表并上传至微信后台，商品才可以被正常使用。`
        }, null, 8, ["status", "title", "sub-title"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", null, [_hoisted_4, _createElementVNode("span", null, "仅包含本次成功发布的 " + _toDisplayString(_unref(successIds).length) + " 个商品。", 1)]), _hoisted_5])], 64)), exportError.value ? (_openBlock(), _createBlock(_component_a_alert, {
          key: 2,
          type: "warning",
          "show-icon": "",
          message: exportError.value
        }, null, 8, ["message"])) : _createCommentVNode("", true), !finished.value || _unref(failures).length ? (_openBlock(), _createBlock(_component_a_table, {
          key: 3,
          columns: finished.value ? [...columns, {
            title: '处理结果',
            dataIndex: 'result'
          }] : columns,
          "data-source": _unref(rows),
          "row-key": "id",
          pagination: false,
          scroll: {
            y: 420
          },
          size: "small"
        }, {
          bodyCell: _withCtx(({
            column,
            record
          }) => {
            var _record$mallImage, _failureFor;
            return [column.dataIndex === 'prodType' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(_toDisplayString(String(record.prodType) === '20' ? '消耗型' : '非消耗型'), 1)], 64)) : column.dataIndex === 'prodPrice' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_createTextVNode("CNY " + _toDisplayString(record.prodPrice), 1)], 64)) : column.dataIndex === 'mallImage' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 2
            }, [(_record$mallImage = record.mallImage) !== null && _record$mallImage !== void 0 && _record$mallImage.imageUrl ? (_openBlock(), _createBlock(_component_a_image, {
              key: 0,
              src: record.mallImage.imageUrl,
              width: 48,
              height: 48
            }, null, 8, ["src"])) : _createCommentVNode("", true)], 64)) : column.dataIndex === 'optType' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 3
            }, [_createTextVNode(_toDisplayString(optTypes[record.optType] || '-'), 1)], 64)) : column.dataIndex === 'result' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 4
            }, [failureFor(record.id) ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString((_failureFor = failureFor(record.id)) === null || _failureFor === void 0 ? void 0 : _failureFor.message), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(successIds).includes(record.id) ? '发布成功' : '待发布'), 1))], 64)) : _createCommentVNode("", true)];
          }),
          _: 1
        }, 8, ["columns", "data-source"])) : _createCommentVNode("", true), _createVNode(_component_a_space, {
          class: "footer-actions"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_button, {
            disabled: loading.value || downloading.value,
            onClick: close
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(finished.value ? '返回列表' : '返回修改'), 1)]),
            _: 1
          }, 8, ["disabled"]), !finished.value || _unref(retryableFailures).length ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "primary",
            loading: loading.value,
            disabled: downloading.value,
            onClick: publish
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(finished.value ? '仅重试失败商品' : '发布'), 1)]),
            _: 1
          }, 8, ["loading", "disabled"])) : _createCommentVNode("", true), _unref(successIds).length ? (_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            type: "primary",
            loading: downloading.value,
            disabled: loading.value,
            onClick: download
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(exportError.value ? '重试导出' : _unref(failures).length ? '导出成功商品' : '导出本次商品'), 1)]),
            _: 1
          }, 8, ["loading", "disabled"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["open", "title", "width", "closable"]);
    };
  }
});